<template>
   <div class="container_box">
     <nav-box @userInfo='getUserInfo'></nav-box>
     <h1 class="scale_title">{{taskInfo.scaleName}}</h1>
     <p class="guideP" v-html="guideContent"></p>

    <div class="button_next">
      <el-button type="primary" @click="nextTip" style="width:150px;">下一步</el-button>
    </div>
   </div>
</template>
<script>
  import { mapMutations } from "vuex";
  import { request } from "../../network/request";
  import NavBox from '../../components/NavBox.vue'
  export default {
    name:'ScaleInfo',
    data(){
        return{
          userInfo:{},
          taskInfo:{},
          currentGuide:0,
          guideContent:'',
        }
    },
    created(){
     this.getScaleInfo();
    },
    computed:{
      taskNo(){
        return this.$route.params.taskNo
      }
    },
    methods:{
    ...mapMutations(["changeLogin"]),
    getUserInfo(val){
        this.userInfo = val;
    },
    getScaleInfo(){
      request({
        url:'/api/AssessTask/QueryTaskInfo',
        method:'get',
        params:{
          taskNo:this.taskNo
        }
      }).then(res =>{
       if(res.data.code === 21002){
            this.changeLogin({ userToken: "" });
            this.$router.push('/login')
        }else if(res.data.code === 0){
          this.taskInfo = res.data.content;
          this.guideContent=this.taskInfo.scaleGuide[this.currentGuide]
        }else{
          this.$message({type:'error',message:res.data.msg,});
          this.$router.push('/assessTask');
        }
      })
    },
    nextTip(){
     if(this.currentGuide < this.taskInfo.scaleGuide-1){
        this.currentGuide ++;
        this.guideContent = this.taskInfo.scaleGuide[this.currentGuide]
      }else{
        this.$router.push('/scaleTest/'+this.taskNo);
      }
    }
  },
   components:{
    NavBox
  }
 }
</script>
<style scoped>
  .container_box{
    padding:50px;
    padding-top:150px;
  }
  .scale_title{
    text-align:center;
    font-size:25px;
    font-family: -apple-system, "Helvetica Neue", Arial, "PingFang SC",
      "Hiragino Sans GB", STHeiti, "Microsoft YaHei", "Microsoft JhengHei",
      "Source Han Sans SC", "Noto Sans CJK SC", "Source Han Sans CN",
      "Noto Sans SC", "Source Han Sans TC", "Noto Sans CJK TC",
      "WenQuanYi Micro Hei", SimSun, sans-serif;
    letter-spacing: 2px;
    font-weight: 500;
    color:#555;
  }
  .guideP{
    padding-top:35px;
    margin:0 auto;
    width:500px;
    text-indent: 2em;
    color:#555;
    line-height:35px;
    font-size:16px;
  }
  .button_next{
    margin-top:50px;
    text-align: center;
  }
  @media screen and (max-width:480px){
  .container_box{
     padding:20px;
     padding-top:120px;
  }
    .guideP{
      width:100%;
    }
  }
</style>